import { ITimelineItem } from '@clients/timelineClient';
import TimelineDetailsBodyCard from '@components/timelineDetails/timelineDetailsBodyFactory/TimelineDetailsBodyCard';
import TimelineDetailsBodyCashIn from '@components/timelineDetails/timelineDetailsBodyFactory/TimelineDetailsBodyCashIn';
import TimelineDetailsBodyConfirmation from '@components/timelineDetails/timelineDetailsBodyFactory/TimelineDetailsBodyConfirmation';
import TimelineDetailsBodyStatement from '@components/timelineDetails/timelineDetailsBodyFactory/TimelineDetailsBodyStatement';
import TimelineDetailsBodyTransaction from '@components/timelineDetails/timelineDetailsBodyFactory/TimelineDetailsBodyTransaction';

interface TimelineDetailsProps {
    timelineItem: ITimelineItem;
    isLoading?: boolean;
}

const TimelineDetailsBodyFactory = ({
    timelineItem,
    isLoading,
}: TimelineDetailsProps) => {
    if (isLoading) {
        const dummy: ITimelineItem = {
            type: 'CARD',
            account_id: 0,
            category: '',
            tenant_account_timestamp: '',
            timestamp: '',
            data: { item: {} },
            correlation_id: '',
        };

        return (
            <TimelineDetailsBodyStatement
                timelineItem={dummy}
                isLoading={isLoading}
            />
        );
    }

    let back = null;
    switch (timelineItem?.type) {
        case 'STATEMENT':
            back = (
                <TimelineDetailsBodyStatement
                    timelineItem={timelineItem}
                    isLoading={isLoading}
                />
            );
            break;
        case 'TRANSACTION':
            back = (
                <TimelineDetailsBodyTransaction
                    timelineItem={timelineItem}
                    isLoading={isLoading}
                />
            );
            break;
        case 'CONFIRMATION':
            back = (
                <TimelineDetailsBodyConfirmation
                    timelineItem={timelineItem}
                    isLoading={isLoading}
                />
            );
            break;
        case 'CASHIN':
            back = (
                <TimelineDetailsBodyCashIn
                    timelineItem={timelineItem}
                    isLoading={isLoading}
                />
            );
            break;
        case 'CARD':
            back = (
                <TimelineDetailsBodyCard
                    timelineItem={timelineItem}
                    isLoading={isLoading}
                />
            );
            break;
    }

    return <>{back}</>;
};

export default TimelineDetailsBodyFactory;
